import { useEffect } from 'react';

interface UseBeforeUnloadOptions {
  when: boolean;
}

export const useBeforeUnload = ({ when }: UseBeforeUnloadOptions) => {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (!when) return;

      e.preventDefault();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [when]);
};
